"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation } from "@packages/sdk";

import { useInvalidateCommunityQueries } from "./utils/useInvalidateCommunityQueries";

const urlBackendPath =
  "/communities/{community_id}/admin/roster/members" as const;

export const useRequestCommunityAdminRosterMembersDelete = ({
  id,
  ...props
}: { id: number } & Partial<
  UseOpenApiMutationOptions<typeof urlBackendPath, "DELETE">
>) => {
  const invalidateCommunityQueries = useInvalidateCommunityQueries({ id });

  return useOpenApiMutation({
    method: "DELETE",
    onSuccess: (data, variables, context) => {
      invalidateCommunityQueries();
      props.onSuccess?.(data, variables, context);
    },
    urlBackendPath,
    ...props,
  });
};
